import GlobalWarningBar from 'components/ReusableComponents/GlobalWarningBar'
import ClockIcon from 'components/ReusableComponents/Icons/Clock'
import { hotelStatusesCanRegisterCampaign } from 'main/hotelStatuses'
import { useSelector } from 'react-redux'

const CampaignRegistryPendingBar = () => {
  const hotelStatus = useSelector(s => s.hotelDetails.status)
  const isHotelSetupCompleted = useSelector(s => s.hotelDetails.isPreOnboardingCompleted)

  const isCampaignRegistryPending = hotelStatusesCanRegisterCampaign.includes(hotelStatus)

  if (!isCampaignRegistryPending || !isHotelSetupCompleted) {
    return null
  }

  return (
    <GlobalWarningBar
      icon={
        <ClockIcon
          styles={{
            fill: '#b8a713',
            width: '18px',
            height: '18px',
            marginRight: '13px',
            marginTop: '-17px'
          }}
        />
      }
      title="Your campaigns are pending approval from our telecom partners due to a new process they have enforced."
      description="This may take up to 15 days, but we're working to expedite the process. During this period, you will not be charged. We appreciate your patience and will keep you updated. Thank you!"
    />
  )
}

export default CampaignRegistryPendingBar
